export default __webpack_public_path__ + "static/media/close_icon.2717b596.svg";